import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  // 로컬스토리지나 리덕스에서 인증 여부를 확인합니다.
  const localAuth = localStorage.getItem('isAuthenticated') === 'true';
  const {user, isAuthenticated, isGuest} = useSelector(state => state.auth);

  if (!isAuthenticated && !localAuth && !isGuest) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && user?.role !== 'ADMIN') {
    alert("관리자만 접근할 수 있습니다.");
    return <Navigate to="/topics" replace />;
  }

  return children;
};

export default ProtectedRoute;